import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";

export class ColumnCustom extends ColumnBase {

    public getContent(row: any): HTMLElement {
        if (this.table.props.getCustomContent) {
            return this.table.props.getCustomContent(this.field, row);
        }
        return <div></div>;
    }

}